import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	standalone: true,
	name: 'formatterDlcsSurUneSeuleLigne'
})
export class FormatterDlcsSurUneSeuleLignePipe implements PipeTransform {

	transform(dlcsFournisseurs: any, args?: any): string {
		return dlcsFournisseurs ? dlcsFournisseurs.replace(/,/g, ', ') : '';
	}

}
